import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  SideNavComponent,
  SideBar,
  ChevronIconWrapper,
  HideChevron,
  NotificationsIconWrapper,
  Notifications,
  SideBarContent,
  HideText,
  HideChevronContentWrapper,
  HideChevronContent,
  NotificationsWrapper,
  NotificationsCTA,
  ContentNotificationsIconWrapper,
  Header,
} from './NotificationsSideBar.styles.js';
import Notification from 'components/notifications-side-bar/Notification';
import { GlobalContext } from 'components/context/GlobalContext';
import { Auth } from 'components/context/AuthContext';
import LoadingSpinner from 'components/_common/loading-spinner/LoadingSpinner.js';
import { ReactHtmlParser } from 'helpers/utilities.js';

const NotificationsSideBar = ({ labels, cta, header, mobile = false }) => {
  const [listOfNotificationId, setListOfNotificationId] = useState([]);

  const { notifications, notificationCount, notifLoading, isRead } = useContext(Auth);

  const {
    globalDispatch,
    globalState: { isOpenNotificationSideBar },
  } = useContext(GlobalContext);

  const notificationsSideBarHeader = notificationCount + ' ' + header;

  useEffect(() => {
    globalDispatch({
      type: 'NOTIFICATIONS_HEADER',
      payload: {
        notificationsSideBarHeader,
      },
    });
  }, [globalDispatch, header, notificationsSideBarHeader]);

  const { notifications_sidebar_hide_label: hideText } = labels || {};
  const { target, title: linkText, isExternal } = cta || {};

  const toggleSidebar = () => {
    globalDispatch({
      type: 'TOGGLE_NOTIFICATION_SIDEBAR',
    });
  };
  useEffect(() => {
    if (notifications) {
      const notificationsIdArray = notifications.map((id) => id.notificationId);
      setListOfNotificationId(notificationsIdArray);
    }
  }, [notifications]);

  return (
    <SideNavComponent open={isOpenNotificationSideBar}>
      <SideBarContent openNotificationsSideBar={isOpenNotificationSideBar} mobile={mobile}>
        <HideText mobile={mobile}>
          {hideText}
          <HideChevronContentWrapper onClick={() => toggleSidebar()}>
            <HideChevronContent name="chevron" noMargin />
          </HideChevronContentWrapper>
        </HideText>

        {notifLoading ? (
          <LoadingSpinner place="notification-sidebar" />
        ) : (
          <>
            <Header>
              <ContentNotificationsIconWrapper notificationCount={notificationCount}>
                <Notifications name="notifications" />
              </ContentNotificationsIconWrapper>
              {` ${ReactHtmlParser(notificationsSideBarHeader)}`}
            </Header>
            <NotificationsWrapper read={isRead}>
              {notifications?.map((notification, index) => (
                <Notification key={index} {...notification} closeSideBar={() => toggleSidebar()} />
              ))}
            </NotificationsWrapper>
            {/* <BtnLoadMore dark onClick={loadNewNOtification}>
              Load More
            </BtnLoadMore> */}
            <NotificationsCTA
              linkText={linkText}
              linkHref={
                listOfNotificationId[0]
                  ? `/dashboard-pages/notification-list?notificationId=${listOfNotificationId[0]}`
                  : `/dashboard-pages/notification-list`
              }
              target={target}
              isExternal={isExternal}
              onClick={() => toggleSidebar()}
              dark
            />
          </>
        )}
      </SideBarContent>
      <SideBar openNotificationsSideBar={isOpenNotificationSideBar} mobile={mobile}>
        <ChevronIconWrapper onClick={() => toggleSidebar()}>
          <HideChevron open={isOpenNotificationSideBar} name="chevron" />
        </ChevronIconWrapper>
        <NotificationsIconWrapper notificationCount={notificationCount}>
          <Notifications name="notifications" />
        </NotificationsIconWrapper>
      </SideBar>
    </SideNavComponent>
  );
};

NotificationsSideBar.propTypes = {
  labels: PropTypes.object,
  notifications: PropTypes.array,
  cta: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    isExternal: PropTypes.bool,
  }),
  header: PropTypes.string,
  mobile: PropTypes.bool,
  userId: PropTypes.number,
};

export default NotificationsSideBar;
